import { ticketServiceApi } from "../../../../app/superAdmin/ticketServiceApi";
import { API_URL } from "../../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../../types";
import {
  AllTagsResponse,
  AllTemplateCategoryResponse,
  AllTemplateParams,
  AllTemplateResponse,
  TemplateDetailsResponse,
} from "./template.type";

export const templateApi = ticketServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // Queries
    getAllTemplates: builder.query<
      AllTemplateResponse,
      GetQueryArgsType<AllTemplateParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllTickets,
        ...queryArgs,
      }),
      providesTags: ["GetAllTemplates"],
    }),

    getTemplateDetails: builder.query<TemplateDetailsResponse, any>({
      query: (id) => ({
        url: `${API_URL.getTicketDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetAllTemplates", id }],
    }),

    getAllTemplateCategories: builder.query<AllTemplateCategoryResponse, void>({
      query: () => ({
        url: API_URL.getAllCategories,
      }),
      providesTags: ["GetAllCategories"],
    }),

    getAllTemplateTags: builder.query<AllTagsResponse, void>({
      query: () => ({
        url: `${API_URL.getTags}`,
      }),
      providesTags: ["GetTags"],
    }),

    // Mutations
    createTemplate: builder.mutation({
      query: (data) => ({
        url: API_URL.createTicket,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetAllTemplates"],
    }),

    updateTemplate: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateTicket}/${id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        return [
          "GetAllTemplates",
          "GetRaiseTickets",
          "GetAllMyTicketDetails",
          { type: "GetAllTemplates", id: result?.data?.id },
        ];
      },
    }),

    deleteTemplate: builder.mutation({
      query: ({ id }) => ({
        url: `${API_URL.deleteTicket}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["GetAllTemplates"],
    }),

    checkKeyAvailability: builder.mutation({
      query: (data) => ({
        url: API_URL.checkTemplateKeyAvailability,
        method: "POST",
        body: data,
      }),
    }),

    updateTemplateStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateTicketStatus}/${id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetAllTemplates"],
    }),

    createTemplateCategory: builder.mutation({
      query: (data) => ({
        url: API_URL.createCategory,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetAllCategories"],
    }),

    updateTemplateCategory: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.updateCategory}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["GetAllCategories"],
    }),
  }),
});

export const {
  // Queries
  useGetAllTemplatesQuery,
  useGetTemplateDetailsQuery,
  useGetAllTemplateCategoriesQuery,
  useGetAllTemplateTagsQuery,

  // Mutations
  useCreateTemplateMutation,
  useUpdateTemplateMutation,
  useDeleteTemplateMutation,
  useCheckKeyAvailabilityMutation,
  useUpdateTemplateStatusMutation,
  useCreateTemplateCategoryMutation,
  useUpdateTemplateCategoryMutation,
} = templateApi;
